import React, { useState } from 'react'
import { Box, Grid, TextField, MenuItem } from '@material-ui/core'
import { useStyles } from './style'

function SystemsChart() {
  const classes = useStyles()

  const [program, setProgram] = useState('')
  const [programName, setProgramName] = useState('')
  const [days, setDays] = useState()

  const handleProgramChange = (e) => {
    setProgram(e.target.value)
  }

  const handleProgramNameChange = (e) => {
    setProgramName(e.target.value)
  }

  const handleDaysChange = (e) => {
    setDays(e.target.value)
  }

  return (
    <Box p={2}>
      <div className={classes.headerWrapper}>
        <Grid container item xs={12} spacing={2} alignItems="center">
          <Grid item xs={12} sm={3} md={6}>
            <span>Systems Overview</span>
          </Grid>
          <Grid item xs={12} sm={3} md={2}>
            <TextField
              id="1"
              fullWidth
              select
              label="Select Program"
              onChange={handleProgramChange}
              InputProps={{
                classes: { root: classes.input }
              }}
              SelectProps={{
                MenuProps: {
                  classes: { paper: classes.paper },
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                  },
                  getContentAnchorEl: null
                }
              }}
            >
              <MenuItem value="energyhub">Energy Hub</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} sm={3} md={2}>
            <TextField
              id="2"
              fullWidth
              select
              label="Select Program Name"
              onChange={handleProgramNameChange}
              InputProps={{
                classes: { root: classes.input }
              }}
              SelectProps={{
                MenuProps: {
                  classes: { paper: classes.paper },
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                  },
                  getContentAnchorEl: null
                }
              }}
            >
              <MenuItem value="connectedSolutions">connectedSolutions-NG-MA</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} sm={3} md={2}>
            <TextField
              id="3"
              fullWidth
              select
              label="View Data of"
              onChange={handleDaysChange}
              InputProps={{
                classes: { root: classes.input }
              }}
              SelectProps={{
                MenuProps: {
                  classes: { paper: classes.paper },
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                  },
                  getContentAnchorEl: null
                }
              }}
            >
              <MenuItem value="14days">Last 14 Days</MenuItem>
            </TextField>
          </Grid>
        </Grid>
      </div>
      <Box mt={2}>
        <div>Chart</div>
        <div>{program} {programName} {days}</div>
      </Box>
    </Box>
  )
}

export default SystemsChart